export default __webpack_public_path__ + "static/media/background.42e497c8.jpg";